<template>
  <div class="ma-2" v-if="tiene_permiso">
    <v-card>
      <v-card-title primary-title>
        <h3 class="headline mb-0">Listado de Sucursales Y nits</h3>
        <v-spacer></v-spacer>
        <!-- <download-excel v-if="sucursales.length" :fields="json_fields" name="sucursales.xls" :data="sucursales">
          <v-btn type="button" rounded color="success" dark class="mb-2 mx-2"> <v-icon class="mr-1">mdi-microsoft-excel</v-icon> Exportar </v-btn>
        </download-excel> -->

        <!-- fomulario crear o editar -->
        <!-- <create-update-form ref="refForm" :editedIndex.sync="editedIndex"></create-update-form> -->
      </v-card-title>
      <v-card-text class="mt-2">
        <p class="my-1"><b>ID/Sede:</b> {{ this.$store.state.CARGO.sede.id }} - {{ this.$store.state.CARGO.sede.nombre }}</p>
        <br />
        <p class="my-1"><b>Matriz:</b> {{ matriz.direccion }} {{ matriz.ciudad }}</p>
        <p class="my-1">
          <b>Sucural:</b> <span class="red--text font-weight-bold">{{ sucursal.numero_sucursal }}</span> {{ sucursal.direccion }} {{ sucursal.ciudad }}
        </p>
        <p class="my-1">
          <strong>NIT:</strong> <span class="primary--text font-weight-bold">{{ sucursal.nit.nro }}</span>
        </p>
        <v-data-table :items-per-page="-1" :search="search" :headers="headers" :items="sucursales" class="elevation-1" :item-class="itemRowBackground">
          <template v-slot:top>
            <v-toolbar flat>
              <v-text-field autofocus outlined dense v-model="search" append-icon="mdi-magnify" label="Buscar" hide-details />
            </v-toolbar>
          </template>
          <template #[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="success" class="ma-1" @click="detailItem(item)"> mdi-eye </v-icon>
              </template>
              Ver Detalle
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="info" class="ma-1" @click="editItem(item)"> mdi-book-edit </v-icon>
              </template>
              Editar
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <show-detail ref="refDetails" @showedit="editItem"></show-detail>
  </div>
  <div class="pa-3" v-else>
    <p class="red--text text-center">
      <v-icon color="red">mdi-block-helper</v-icon>
      <br />
      Usuario no autorizado para este visualizar este contenido
    </p>
  </div>
</template>

<script>
// import CreateUpdateForm from './CreateUpdateForm';
import ShowDetail from './ShowDetail';
import gql from 'graphql-tag';

export default {
  components: {
    // CreateUpdateForm,
    ShowDetail,
  },
  data() {
    return {
      search: '',
      matriz: '',
      sucursal: '',
      tiene_permiso: true,
      editedIndex: -1,
      headers: [
        // { text: 'id', value: 'id' },
        { text: 'Sede ', value: 'sede.nombre' },
        { text: 'N° Sucursal', value: 'numero_sucursal' },
        { text: 'Numero Nit', value: 'nit.nro' },
        { text: 'Direccion', value: 'direccion' },
        { text: 'Ciudad', value: 'ciudad' },
        { text: 'Telefono', value: 'telefono' },
        // { text: 'Acciones', value: 'actions', sortable: false },
      ],
      sucursales: [],
      json_fields: {
        id: 'id',
        nombre: 'sede.nombre',
        numero_sucursal: 'numero_sucursal',
        nit: 'nit.nro',
        direccion: 'direccion',
        ciudad: 'ciudad',
        telefono: 'telefono',
      },
    };
  },
  watch: {
    '$store.state.CARGO.sede': function () {
      this.loadSucursales();
    },
  },
  methods: {
    async loadSucursales() {
      this.getSucursales(await this.getNits(), await this.getSedes());
    },
    detailItem(item) {
      this.$refs.refDetails.showDialog(item);
    },
    editItem(item) {
      this.editedIndex = this.sucursales.indexOf(item);
      this.$refs.refForm.showDialog(item);
    },

    getSucursales(nits, sedes) {
      const qs = gql`query{ ${''} getSucursales{ id,nit_id,direccion,telefono,ciudad,numero_sucursal,sede_id } }`;
      this.$apollo.query({ query: qs }).then(({ data }) => {
        if (data.getSucursales.length) {
          this.sucursales = data.getSucursales.map((suc) => {
            suc.nit = nits.find((nit) => nit.id == suc.nit_id);
            suc.sede = sedes.find((sede) => sede.id == suc.sede_id);
            return suc;
          });
          this.sucursal = this.sucursales.find((item) => item.sede_id == this.$store.state.CARGO.sede.id);
          this.matriz = this.sucursales.find((s) => s.numero_sucursal === 0 && s.nit.nro == this.sucursal.nit.nro);
        }
      });
    },
    getNits() {
      const qs = gql`query{ ${''} getNits{ id, nombre, descripcion, nro, estado }}`;
      return this.$apollo.query({ query: qs }).then(({ data }) => (data.getNits ? data.getNits : []));
    },
    getSedes() {
      const qs = gql`query ${''} { getSedes { id nombre direccion }}`;
      return this.$apollo
        .query({ query: qs })
        .then(({ data }) => (data.getSedes ? data.getSedes : []))
        .catch(() => []);
    },
    itemRowBackground(item) {
      return item.numero_sucursal ? '' : 'casa_matriz';
    },
  },
  async mounted() {
    this.loadSucursales();
  },
};
</script>

<style>
.casa_matriz {
  background-color: #0051ff33;
}
</style>
